(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog"] && !Shopify.designMode) return;
  try {
    
class CatalogNav extends HTMLElement {
  connectedCallback() {
    this.chips = this.querySelectorAll('[data-catalog-chip]');
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    for (const chip of this.chips) {
      chip.addEventListener('click', this.handleClick.bind(this));
    }
  }

  handleClick(event) {
    const href = event.currentTarget.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({
      behavior: this.reduced ? 'auto' : 'smooth',
      block: 'start',
    });
    if (history.replaceState) {
      history.replaceState(null, '', href);
    }
  }
}

if (!customElements.get('catalog-nav')) {
  customElements.define('catalog-nav', CatalogNav);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
  /* B4 · חיצי המגזין במובייל (04.10.2026). ה-track הוא שורת הגלילה של הכרטיסים;
     "הבא" = הכרטיס הבא בסדר הקריאה. ב-RTL זה שמאלה, ולכן הסימן נגזר מ-direction
     (scrollLeft שלילי ב-RTL ב-Chromium וב-WebKit). הגרירה באצבע לא נוגעת כאן,
     והחיצים רק מסנכרנים את מצבם (disabled בקצוות) לפי מיקום הגלילה. */
  class GlowMagNav extends HTMLElement {
    connectedCallback() {
      this.track = document.getElementById(this.dataset.track || '');
      this.prevBtn = this.querySelector('[data-glow-mag-prev]');
      this.nextBtn = this.querySelector('[data-glow-mag-next]');
      if (!this.track || !this.prevBtn || !this.nextBtn) return;

      this.onPrev = () => this.go(-1);
      this.onNext = () => this.go(1);
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.sync();
        });
      };
      this.prevBtn.addEventListener('click', this.onPrev);
      this.nextBtn.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if ('ResizeObserver' in window) {
        this.resizer = new ResizeObserver(() => this.sync());
        this.resizer.observe(this.track);
      }
      this.sync();
    }

    disconnectedCallback() {
      this.prevBtn?.removeEventListener('click', this.onPrev);
      this.nextBtn?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    rtlSign() {
      return getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
    }

    step() {
      const cards = Array.from(this.track.children).filter((el) => el.getClientRects().length > 0);
      if (cards.length < 2) return this.track.clientWidth || 1;
      const first = cards[0].getBoundingClientRect();
      const second = cards[1].getBoundingClientRect();
      return Math.abs(second.left - first.left) || first.width || 1;
    }

    offset() {
      return Math.abs(this.track.scrollLeft);
    }

    limit() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    go(delta) {
      const step = this.step();
      const index = Math.round(this.offset() / step) + delta;
      const target = Math.min(this.limit(), Math.max(0, index * step));
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.rtlSign() * target, behavior: reduce ? 'auto' : 'smooth' });
    }

    sync() {
      const offset = this.offset();
      const limit = this.limit();
      this.toggle(this.prevBtn, offset <= 2, this.nextBtn);
      this.toggle(this.nextBtn, offset >= limit - 2, this.prevBtn);
    }

    toggle(button, off, other) {
      if (button.disabled === off) return;
      const hadFocus = document.activeElement === button;
      button.disabled = off;
      if (off && hadFocus && !other.disabled) other.focus();
    }
  }

  if (!customElements.get('glow-mag-nav')) {
    customElements.define('glow-mag-nav', GlowMagNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-glow-cookie-settings]');
    if (!trigger) return;
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      event.preventDefault();
      window.privacyBanner.showPreferences();
    }
  });

  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glow-club-signup"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Glow Customer Hub — ingest keepalive (מקביל ל-native, לא חוסם). window-guarded
     → מוגדר פעם אחת גם אם glow-cart.js / סקשן אחר כבר הגדיר. */
  window.glowHubIngest = window.glowHubIngest || function (email, source, detail) {
    try {
      if (!email && source !== 'checkout') return; /* checkout מותר אנונימי — יומן העגלות */
      /* זיכרון-מייל (כוונת-רכש): הרשמה מזוהה → הדפדפן זוכר, ולחיצת "לתשלום" עתידית
         תיקשר למסע הלקוחה גם בלי מייל בצ'קאאוט. localStorage בלבד, לא נשלח לצד-שלישי. */
      try {
        if (email && /\S+@\S+\.\S+/.test(email)) localStorage.setItem('glow_known_email', String(email).trim().toLowerCase());
      } catch (err) { /* private mode */ }
      var url = 'https://glow-customer-hub.glowvitamininsights.workers.dev/ingest';
      /* sendBeacon + Blob text/plain = simple request (בלי CORS preflight) ששורד ניווט-דף —
         הדפוס המוכח של glow-consent-beacon (תוקן 3.8: fetch+json נהרג עם ה-navigation). */
      var payload = new Blob([JSON.stringify({ email: email, source: source, detail: detail || {} })], { type: 'text/plain' });
      var sent = false;
      try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(url, payload)); } catch (err) { sent = false; }
      if (!sent) {
        fetch(url, { method: 'POST', keepalive: true, mode: 'no-cors', body: payload }).catch(function () {});
      }
    } catch (e) {}
  };

  /* snapshot עגלה ל-ingest (תוספת 3.8, אישור עילי): נטען על focus בטופס (throttle 10ש'),
     נשלח כ-detail.cart באותו פורמט של הסולד-אאוט — ה-Hub מרנדר אותו ב"מסע הלקוחה". */
  var _clubCart = null, _clubCartTs = 0;
  function glowClubCartSummary(c) {
    var items = (c.items || []).map(function (i) {
      var lineCents = (typeof i.final_line_price === 'number') ? i.final_line_price
        : (typeof i.line_price === 'number') ? i.line_price : 0;
      var unitCents = (typeof i.final_price === 'number') ? i.final_price
        : (typeof i.price === 'number') ? i.price : 0;
      return { title: i.product_title, qty: i.quantity,
        line_price: Math.round(lineCents) / 100, unit_price: Math.round(unitCents) / 100 };
    });
    return { items: items, count: c.item_count,
      subtotal: Math.round(c.items_subtotal_price || 0) / 100,
      original_total: Math.round(c.original_total_price || 0) / 100,
      discount: Math.round(c.total_discount || 0) / 100,
      total: Math.round(c.total_price || 0) / 100,
      currency: c.currency || 'ILS' };
  }
  document.addEventListener('focusin', function (e) {
    try {
      if (!e.target || !e.target.closest || !e.target.closest('[data-glow-club-form]')) return;
      if (Date.now() - _clubCartTs < 10000) return;
      _clubCartTs = Date.now();
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) _clubCart = c; })
        .catch(function () {});
    } catch (err) { /* לא-קריטי */ }
  });

  var PENDING_KEY = 'glow_club_pending';
  var EMAIL_KEY = 'glow_club_email';   /* שחזור-קלט אחרי reload-עם-שגיאה (UX, לא resubmit) */
  var PHONE_KEY = 'glow_club_phone';   /* שחזור-קלט אחרי reload-עם-שגיאה (UX, לא resubmit) */
  var TS_KEY = 'glow_club_ts';
  /* חלון זמן שבו PENDING נחשב "טרי" (submit → captcha → חזרה). מעבר לזה מתעלמים
     מ-PENDING תקוע (למשל נטישת captcha + חזרה ידנית) כדי לא להציג אישור כוזב. */
  var FRESH_MS = 20 * 60 * 1000;

  /* נרמול טלפון ישראלי ל-E.164: 05XXXXXXXX → +9725XXXXXXXX (גם עם מקפים/רווחים).
     מחזיר {ok, value} — ok=false אם לא-ריק ולא-תקין. ריק = ok=true, value=''. */
  function normalizeIsraeliPhone(raw) {
    var trimmed = (raw || '').trim();
    if (trimmed === '') return { ok: true, value: '' };

    var digits = trimmed.replace(/[\s\-().]/g, '');
    if (digits.charAt(0) === '+') {
      digits = '+' + digits.slice(1).replace(/\D/g, '');
    } else {
      digits = digits.replace(/\D/g, '');
    }

    var national = null;
    if (digits.indexOf('+972') === 0) {
      national = '0' + digits.slice(4);
    } else if (digits.indexOf('972') === 0) {
      national = '0' + digits.slice(3);
    } else if (digits.charAt(0) === '0') {
      national = digits;
    } else {
      return { ok: false, value: trimmed };
    }

    /* נייד ישראלי 05X + 7 ספרות (10 ספרות סה"כ). */
    if (!/^05\d{8}$/.test(national)) {
      return { ok: false, value: trimmed };
    }
    return { ok: true, value: '+972' + national.slice(1) };
  }

  function getForm() {
    return document.querySelector('[data-glow-club-form]');
  }

  /* מעביר את המודאל ל-<body> פעם אחת — יוצא מ-.glow-club__card (overflow:hidden +
     isolation) כדי לא להיתקע ב-stacking context ולא להיחתך (דפוס ensureModalOnBody). */
  function ensureModalOnBody(modal) {
    if (modal && modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
  }

  /* פותח את מודאל אישור ההצלחה (modal-dialog של Symmetry — open/close/Escape/
     trap-focus; open() ממקד את הכפתור הראשון = כפתור הסגירה). */
  function openClubSuccessModal() {
    var modal = document.getElementById('GlowClubSuccessModal');
    if (!modal || typeof modal.open !== 'function') return;
    ensureModalOnBody(modal);
    window.requestAnimationFrame(function () { modal.open(); });
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || typeof form.matches !== 'function' || !form.matches('[data-glow-club-form]')) return;

    var phoneInput = form.querySelector('[data-glow-club-phone]');
    var errorEl = document.getElementById('glow-club-phone-error');
    /* לוכד את הטלפון הגולמי (מה שהמשתמשת הקלידה) לפני נרמול — לשחזור אם השרת ידחה */
    var rawPhone = phoneInput ? phoneInput.value : '';
    var glowClubNormPhone = ''; /* E.164 המנורמל — ל-Hub ingest */

    if (phoneInput) {
      var res = normalizeIsraeliPhone(phoneInput.value);
      if (!res.ok) {
        evt.preventDefault();
        phoneInput.setAttribute('aria-invalid', 'true');
        if (errorEl) {
          errorEl.textContent = 'מספר הטלפון לא תקין. הזיני מספר נייד ישראלי (למשל 050-1234567), או השאירי ריק.';
          errorEl.hidden = false;
        }
        phoneInput.focus();
        return;
      }
      phoneInput.removeAttribute('aria-invalid');
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      /* ריק → משביתים כדי לא לשלוח note ריק; אחרת מזינים E.164 */
      if (res.value === '') {
        phoneInput.disabled = true;
      } else {
        phoneInput.value = res.value;
        glowClubNormPhone = res.value;
      }
    }

    /* Glow Customer Hub — הצטרפות למועדון + טלפון מנורמל (מקביל ל-native, לא חוסם) */
    try {
      var hubEmailEl = form.querySelector('[data-glow-club-email]');
      if (hubEmailEl && hubEmailEl.value) {
        var clubDetail = {};
        if (glowClubNormPhone) clubDetail.phone = glowClubNormPhone;
        if (_clubCart && _clubCart.items && _clubCart.items.length) clubDetail.cart = glowClubCartSummary(_clubCart);
        window.glowHubIngest(hubEmailEl.value, 'club', clubDetail);
      }
    } catch (e) { /* לא-חוסם את ה-native submit */ }

    /* דגל + שמירת אימייל וטלפון-גולמי (לשחזור הקלטים אם השרת ידחה — כדי שלא
       "יימחקו" אחרי ה-reload; UX בלבד, לא resubmit) */
    try {
      sessionStorage.setItem(PENDING_KEY, '1');
      sessionStorage.setItem(TS_KEY, String(Date.now()));
      var emailInput = form.querySelector('[data-glow-club-email]');
      if (emailInput) sessionStorage.setItem(EMAIL_KEY, emailInput.value);
      sessionStorage.setItem(PHONE_KEY, rawPhone);
    } catch (e) { /* incognito וכו' */ }

    var submitBtn = form.querySelector('[data-glow-club-submit]');
    if (submitBtn) { submitBtn.classList.add('is-loading'); submitBtn.setAttribute('aria-busy', 'true'); }
    /* אין preventDefault (כשתקין) — נשלח נייטיבית: reCAPTCHA + navigation */
  });

  /* אחרי ה-native submit + redirect חזרה ל-/#club-signup:
     - הצלחה (PENDING שלנו + טרי + אפס שגיאות) → מציגים view הצלחה + מודאל.
     - שגיאה → משחזרים קלטים + form-errors inline (note-invalid כבר לא אפשרי — הטלפון בלי name).
     ⚠️ לא נשענים על form.posted_successfully? (ה-marker) — reCAPTCHA שובר את ה-flash
     הזה: ה-customer נוצר, אבל אחרי עמוד-האתגר ה-marker לא מרונדר בטעינה החוזרת, וכך
     האישור לא הוצג (הבאג שעילי דיווח). ה-PENDING נקבע רק ב-submit של הטופס שלנו → הוא
     הסימן האמין. guard: TS טרי (חלון captcha סביר) מונע אישור-כוזב מ-PENDING תקוע. */
  function handlePostback() {
    var pending = false, ts = 0;
    try {
      pending = sessionStorage.getItem(PENDING_KEY) === '1';
      ts = parseInt(sessionStorage.getItem(TS_KEY) || '0', 10);
    } catch (e) { pending = false; }
    if (!pending) return;

    var form = getForm();
    if (!form) return;

    /* PENDING לא-טרי (סשן ישן / נטישת captcha + חזרה ידנית) → ניקוי בלי אישור */
    if (!ts || (Date.now() - ts) > FRESH_MS) { clearFlags(); return; }

    var errorBox = document.getElementById('glow-club-error');
    var hasError = !!(errorBox && errorBox.textContent && errorBox.textContent.trim() !== '');
    var successView = document.querySelector('[data-glow-club-success]');
    var section = document.getElementById('club-signup');

    if (hasError) {
      /* שגיאה (מייל תפוס וכו') — שחזור הקלטים שהמשתמשת מילאה + שגיאה inline + פוקוס.
         note-invalid כבר לא אפשרי: שדה הטלפון בלי name → לא נשלח ב-POST. */
      var storedPhone = '', storedEmail2 = '';
      try { storedPhone = sessionStorage.getItem(PHONE_KEY) || ''; storedEmail2 = sessionStorage.getItem(EMAIL_KEY) || ''; } catch (e) { /* noop */ }
      var emailEl = form.querySelector('[data-glow-club-email]');
      var phoneEl = form.querySelector('[data-glow-club-phone]');
      if (emailEl && !emailEl.value && storedEmail2) emailEl.value = storedEmail2;
      if (phoneEl && storedPhone) { phoneEl.disabled = false; phoneEl.value = storedPhone; }
      clearFlags();
      scrollToSection(section);
      if (emailEl && typeof emailEl.focus === 'function') {
        window.requestAnimationFrame(function () { emailEl.focus(); });
      }
      return;
    }

    /* ---- הצלחה (posted רגיל *או* captcha) ---- */
    clearFlags();
    publishClubLead();
    if (form) form.hidden = true;
    if (successView) successView.hidden = false;
    scrollToSection(section);
    openClubSuccessModal();
  }

  /* אנליטיקה בלבד — glow_lead (source:'club') בהרשמה מוצלחת. guard מלא +
     try/catch; לא-קריטי, לעולם לא שובר את ההרשמה (עובד מלא גם בלי GA4). */
  function publishClubLead() {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    try {
      window.Shopify.analytics.publish('glow_lead', { source: 'club' });
    } catch (e) { /* אנליטיקה לא-קריטית */ }
  }

  function clearFlags() {
    try {
      sessionStorage.removeItem(PENDING_KEY);
      sessionStorage.removeItem(EMAIL_KEY);
      sessionStorage.removeItem(PHONE_KEY);
      sessionStorage.removeItem(TS_KEY);
    } catch (e) { /* noop */ }
  }

  /* ולידציה חיה עדינה: מנקים את הודעת השגיאה ברגע שהמשתמשת מתקנת (input event),
     במקום להשאיר אותה עד ה-submit הבא. */
  function initLiveValidation() {
    var phoneInput = document.querySelector('[data-glow-club-phone]');
    if (!phoneInput) return;
    phoneInput.addEventListener('input', function () {
      if (phoneInput.getAttribute('aria-invalid') !== 'true') return;
      phoneInput.removeAttribute('aria-invalid');
      var errorEl = document.getElementById('glow-club-phone-error');
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    });
  }

  function scrollToSection(section) {
    if (!section || typeof section.scrollIntoView !== 'function') return;
    window.requestAnimationFrame(function () {
      section.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function init() {
    handlePostback();
    initLiveValidation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glow-help-hub"] && !Shopify.designMode) return;
  try {
    
  class GlowHelpHub extends HTMLElement {
    connectedCallback() {
      this.tablist = this.querySelector('.glow-help-hub__tablist');
      this.tabs = Array.from(this.querySelectorAll('.glow-help-hub__tab'));
      this.inner = this.querySelector('.glow-help-hub__inner');
      if (!this.tabs.length) return;

      this.ids = this.tabs.map((tab) => tab.dataset.tab);
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.desktopMQ = window.matchMedia('(min-width: 900px)');

      this.onTablistClick = this.onTablistClick.bind(this);
      this.onTablistKeydown = this.onTablistKeydown.bind(this);
      this.onScrollToClick = this.onScrollToClick.bind(this);
      this.onHashChange = this.onHashChange.bind(this);
      this.onPopState = this.onPopState.bind(this);
      this.syncOrientation = this.syncOrientation.bind(this);

      this.tablist.addEventListener('click', this.onTablistClick);
      this.tablist.addEventListener('keydown', this.onTablistKeydown);
      this.addEventListener('click', this.onScrollToClick);
      window.addEventListener('hashchange', this.onHashChange);
      window.addEventListener('popstate', this.onPopState);
      this.desktopMQ.addEventListener('change', this.syncOrientation);
      this.syncOrientation();

      // אחרי POST של טופס native (contact/cancellation) Shopify מוסיף anchor ל-id
      // של הטופס (#GlowContactForm / #GlowCancelForm) — לא ל-tab. idFromHash מחזיר
      // null → ברירת-המחדל נופלת לטאב הראשון (shipping) והמשתמשת לא רואה את הודעת
      // ההצלחה/שגיאה שמרונדרת בטאב מוסתר. לכן: אם קיים feedback (success או error)
      // בדף — מזהים את הפאנל שמכיל אותו, בוחרים את הטאב שלו וגוללים אל ההודעה.
      const feedback = this.querySelector('.glow-help-form__feedback');
      const feedbackTab = this.tabFromFeedback(feedback);

      const initial = feedbackTab || this.idFromHash(window.location.hash);
      if (initial) {
        this.selectTab(initial, { focus: false, scrollChip: true });
        if (feedbackTab) this.revealFeedback(feedback);
      } else if (!this.revealHashTarget()) {
        // revealHashTarget מטפל בעוגן שבתוך פאנל (למשל #faq-club מסעיף 6.5 בתקנון).
        this.selectTab(this.ids[0], { focus: false, silent: true });
      }

      for (const form of this.querySelectorAll('form')) this.enhanceForm(form);
    }

    disconnectedCallback() {
      this.tablist?.removeEventListener('click', this.onTablistClick);
      this.tablist?.removeEventListener('keydown', this.onTablistKeydown);
      this.removeEventListener('click', this.onScrollToClick);
      window.removeEventListener('hashchange', this.onHashChange);
      window.removeEventListener('popstate', this.onPopState);
      this.desktopMQ?.removeEventListener('change', this.syncOrientation);
    }

    syncOrientation() {
      if (!this.tablist) return;
      this.tablist.setAttribute('aria-orientation', this.desktopMQ.matches ? 'vertical' : 'horizontal');
    }

    onScrollToClick(event) {
      const trigger = event.target.closest('[data-scroll-to]');
      if (!trigger || !this.contains(trigger)) return;
      const target = this.querySelector('#' + CSS.escape(trigger.dataset.scrollTo));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({
        block: 'start',
        behavior: this.reduceMotion ? 'auto' : 'smooth'
      });
      if (typeof target.focus === 'function') {
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }

    idFromHash(hash) {
      if (!hash) return null;
      const id = hash.replace(/^#/, '');
      return this.ids.includes(id) ? id : null;
    }

    // מחלץ את מזהה-הטאב מתוך הפאנל שמכיל את הודעת ה-feedback שהתקבלה אחרי POST.
    // הפאנל id בפורמט glow-panel-<tid>; מחזיר <tid> רק אם הוא טאב תקין, אחרת null.
    tabFromFeedback(feedback) {
      if (!feedback) return null;
      const panel = feedback.closest('.glow-help-hub__panel');
      if (!panel || !panel.id) return null;
      const prefix = 'glow-panel-';
      if (panel.id.indexOf(prefix) !== 0) return null;
      const tid = panel.id.slice(prefix.length);
      return this.ids.includes(tid) ? tid : null;
    }

    // גולל את הודעת ה-feedback למרכז המסך וממקד אותה (success=status / error=alert)
    // כדי שקוראי-מסך יכריזו עליה. רץ אחרי שהטאב כבר מוצג (hidden הוסר).
    revealFeedback(feedback) {
      if (!feedback) return;
      window.requestAnimationFrame(() => {
        if (typeof feedback.scrollIntoView === 'function') {
          feedback.scrollIntoView({
            block: 'center',
            behavior: this.reduceMotion ? 'auto' : 'smooth'
          });
        }
        feedback.setAttribute('tabindex', '-1');
        if (typeof feedback.focus === 'function') feedback.focus({ preventScroll: true });
      });
    }

    // 12.10.2026 · hash שאינו טאב אבל מצביע על אלמנט בתוך פאנל (למשל #faq-club):
    // פותחים את הפאנל שמכיל אותו (אותו חיפוש-פאנל של tabFromFeedback) וגוללים אליו.
    // מחזיר true רק אם טופל, כדי שטאבים (#faq, #returns...) ימשיכו במסלול הרגיל.
    revealHashTarget() {
      const raw = window.location.hash.replace(/^#/, '');
      if (!raw) return false;
      let id = raw;
      try { id = decodeURIComponent(raw); } catch (e) { id = raw; }
      if (this.ids.includes(id)) return false;
      const target = document.getElementById(id);
      if (!target || !this.contains(target)) return false;
      const tid = this.tabFromFeedback(target);
      if (!tid) return false;
      // בלי אנימציית הכניסה: ה-translateY שלה נמדד ב-scrollIntoView, והיעד "קופץ" 8px
      // מעלה בסופה, אל מתחת לרצועת הטאבים הדביקה. הגלילה עצמה היא התנועה.
      this.selectTab(tid, { focus: false, animate: false });
      window.requestAnimationFrame(() => {
        target.scrollIntoView({
          block: 'start',
          behavior: this.reduceMotion ? 'auto' : 'smooth'
        });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
      return true;
    }

    onTablistClick(event) {
      const tab = event.target.closest('.glow-help-hub__tab');
      if (!tab) return;
      this.activate(tab.dataset.tab, { focus: true });
    }

    onHashChange() {
      if (this.revealHashTarget()) return;
      const id = this.idFromHash(window.location.hash);
      if (!id) return;
      this.selectTab(id, { focus: false, scrollChip: true });
      this.scrollToTop();
    }

    onPopState() {
      if (this.revealHashTarget()) return;
      const id = this.idFromHash(window.location.hash) || this.ids[0];
      this.selectTab(id, { focus: false, scrollChip: true });
      this.scrollToTop();
    }

    onTablistKeydown(event) {
      const current = this.tabs.findIndex((t) => t === document.activeElement);
      if (current === -1) return;
      const rtl = getComputedStyle(this).direction === 'rtl';
      const last = this.tabs.length - 1;
      let next = null;

      switch (event.key) {
        case 'ArrowRight':
          next = rtl ? current - 1 : current + 1;
          break;
        case 'ArrowLeft':
          next = rtl ? current + 1 : current - 1;
          break;
        case 'ArrowDown':
          next = current + 1;
          break;
        case 'ArrowUp':
          next = current - 1;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = last;
          break;
        case 'Enter':
        case ' ':
          event.preventDefault();
          this.activate(this.tabs[current].dataset.tab, { focus: true });
          return;
        default:
          return;
      }

      if (next === null) return;
      event.preventDefault();
      if (next < 0) next = last;
      if (next > last) next = 0;
      this.moveFocus(next);
    }

    moveFocus(index) {
      for (const tab of this.tabs) tab.setAttribute('tabindex', '-1');
      const tab = this.tabs[index];
      tab.setAttribute('tabindex', '0');
      tab.focus();
      this.scrollChipIntoView(tab);
    }

    activate(id, options) {
      this.selectTab(id, options);
      this.scrollToTop();
      const hash = '#' + id;
      if (window.location.hash !== hash) {
        history.pushState(null, '', hash);
      }
    }

    selectTab(id, options) {
      options = options || {};
      const index = this.ids.indexOf(id);
      if (index === -1) return;

      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = !selected;
          if (selected && options.animate !== false) this.animatePanel(panel);
        }
      });

      const active = this.tabs[index];
      if (options.focus) active.focus();
      if (options.scrollChip) this.scrollChipIntoView(active);
    }

    animatePanel(panel) {
      if (this.reduceMotion) return;
      panel.classList.remove('is-animating');
      void panel.offsetWidth;
      panel.classList.add('is-animating');
    }

    scrollChipIntoView(tab) {
      if (typeof tab.scrollIntoView !== 'function') return;
      tab.scrollIntoView({
        block: 'nearest',
        inline: 'center',
        behavior: this.reduceMotion ? 'auto' : 'smooth'
      });
    }

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: this.reduceMotion ? 'auto' : 'smooth'
      });
    }

    enhanceForm(form) {
      const fields = Array.from(form.querySelectorAll('input[required], textarea[required], input[type="email"]'));
      if (!fields.length) return;
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', (event) => {
        let firstInvalid = null;
        for (const field of fields) {
          if (!this.validateField(field) && !firstInvalid) firstInvalid = field;
        }
        if (firstInvalid) {
          event.preventDefault();
          firstInvalid.focus();
        }
      });
      for (const field of fields) {
        field.addEventListener('blur', () => this.validateField(field));
        field.addEventListener('input', () => {
          if (field.getAttribute('aria-invalid') === 'true') this.validateField(field);
        });
      }
    }

    validateField(field) {
      const errorId = field.getAttribute('aria-describedby');
      const errorEl = errorId ? this.querySelector('#' + CSS.escape(errorId)) : null;
      let message = '';
      if (field.validity.valueMissing) {
        message = field.dataset.error || 'נא למלא שדה זה.';
      } else if (field.validity.typeMismatch) {
        message = field.dataset.errorType || 'ערך לא תקין.';
      }
      if (message) {
        field.setAttribute('aria-invalid', 'true');
        if (errorEl) {
          errorEl.textContent = message;
          errorEl.hidden = false;
        }
        return false;
      }
      field.removeAttribute('aria-invalid');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
      return true;
    }
  }

  if (!customElements.get('glow-help-hub')) {
    customElements.define('glow-help-hub', GlowHelpHub);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glow-wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* לכידת המייל — customer form נייטיבי · דפוס 1:1 עם glow-club-signup:
       posted_successfully? משותף ל-form_type=customer, לכן דגל sessionStorage (נקבע רק
       ב-submit של הטופס שלנו) הוא ה-disambiguator. reCAPTCHA שובר את ה-marker flash →
       נשענים על PENDING טרי + היעדר שגיאה. בהצלחה: publish('glow_lead'). */
    var PENDING_KEY = 'glow_wl_capture_pending';
    var EMAIL_KEY = 'glow_wl_capture_email';
    var TS_KEY = 'glow_wl_capture_ts';
    var FRESH_MS = 20 * 60 * 1000;

    function getForm() {
      return document.querySelector('[data-glow-wl-capture-form]');
    }

    function clearFlags() {
      try {
        sessionStorage.removeItem(PENDING_KEY);
        sessionStorage.removeItem(EMAIL_KEY);
        sessionStorage.removeItem(TS_KEY);
      } catch (e) { /* incognito */ }
    }

    function publishLead() {
      if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
      try {
        window.Shopify.analytics.publish('glow_lead', { source: 'wishlist_page' });
      } catch (e) { /* אנליטיקה לא-קריטית */ }
    }

    document.addEventListener('submit', function (evt) {
      var form = evt.target;
      if (!form || typeof form.matches !== 'function' || !form.matches('[data-glow-wl-capture-form]')) return;
      try {
        sessionStorage.setItem(PENDING_KEY, '1');
        sessionStorage.setItem(TS_KEY, String(Date.now()));
        var emailInput = form.querySelector('[data-glow-wl-capture-email]');
        if (emailInput) sessionStorage.setItem(EMAIL_KEY, emailInput.value);
      } catch (e) { /* incognito */ }
      var submitBtn = form.querySelector('[data-glow-wl-capture-submit]');
      if (submitBtn) { submitBtn.classList.add('is-loading'); submitBtn.setAttribute('aria-busy', 'true'); }
      /* אין preventDefault — native submit (reCAPTCHA + navigation) */
    });

    function handlePostback() {
      var pending = false, ts = 0;
      try {
        pending = sessionStorage.getItem(PENDING_KEY) === '1';
        ts = parseInt(sessionStorage.getItem(TS_KEY) || '0', 10);
      } catch (e) { pending = false; }
      if (!pending) return;

      var form = getForm();
      if (!form) return;

      /* PENDING לא-טרי (נטישת captcha / סשן ישן) → ניקוי בלי אישור כוזב */
      if (!ts || (Date.now() - ts) > FRESH_MS) { clearFlags(); return; }

      var errorBox = document.getElementById('glow-wl-capture-error');
      var hasError = !!(errorBox && errorBox.textContent && errorBox.textContent.trim() !== '');
      var successView = document.querySelector('[data-glow-wl-capture-success]');

      if (hasError) {
        /* שגיאה אמיתית — משחזרים אימייל, משאירים form-errors inline */
        var storedEmail = '';
        try { storedEmail = sessionStorage.getItem(EMAIL_KEY) || ''; } catch (e) { /* noop */ }
        var emailEl = form.querySelector('[data-glow-wl-capture-email]');
        if (emailEl && !emailEl.value && storedEmail) emailEl.value = storedEmail;
        clearFlags();
        return;
      }

      /* ---- הצלחה (posted רגיל *או* captcha) ---- */
      clearFlags();
      form.hidden = true;
      if (successView) successView.hidden = false;
      publishLead();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handlePostback);
    } else {
      handlePostback();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
